import React from 'react'

import TypeAnimation from 'components/TypeAnimation'


export default class extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render = () =>
    <div className="description">
      <div className="description__0">
        <TypeAnimation
          texts={["Представьте, что мир полностью изменился…  Попробуйте… Города выглядят иначе: транспорт, архитектура, навигация, нормы поведения, ценности. Деревни трансформировались; экономика, культура, технологии, туризм, блоггинг. Международные отношения эволюционировали; глобальное сообщение, безопасность, исследования, проекты, обмен. Закройте глаза ненадолго, и представьте — прошло много лет и всё изменилось…"]}
        />
      </div>

      <div className="description__1">
        <TypeAnimation
          texts={["Представили?"]}
        />
      </div>

      <div className="description__2">
        <TypeAnimation
          texts={["Мы тоже. Это очень эффективное упражнение для того, чтобы почувствовать зазор между привычностью текущего положения вещей и потенциалом изменчивой реальности. Казалось бы, разве театр занимается дорожной обстановкой в городе? Ведь даже ставший уже известным документальный театр чаще стремится найти какой-то выдающийся предмет рефлексии, или остро-актуальный сюжет, завязанный на историческом прецеденте. Мы думаем, что театр обширен, как космос. Он может заниматься чем угодно, потому что во всём есть связь с глобальным миром, с жизнью человеческого духа и смыслом бытия."]}
        />
      </div>

      <div className="description__3">
        <TypeAnimation
          texts={["Театр-исследование давно является мировым трендом, да и всегда им был, даже когда родился в пьесе, которая звучала с площадки сцены. Теперь же исследования  бывают очень контрастными по форме, но это всегда погружение в предмет, осознанный взгляд в явление. Дорожная обстановка в городе — это обыденность, в которой нет блеска шоу-бизнеса, бархата актовых залов, таинственности интеллектуального стиля. Но дорожная обстановка в городе так же полна причин и следствий, полна жизни и смерти, то есть — она равноправный материал для искусства. Если этот материал собрать и возвести в форму, может произойти контакт, выводящий на полноту отношений между проектом и вами — пользователи перформанса. Мы — команда проекта — были искренне увлечены, поэтому уверены, что создали нечто, во что можно погрузиться. Надеемся, вы тоже ощутите тот невидимый эфир содержания, который шире сухой статистики и привычки."]}
        />
      </div>

      <div className="description__4">
        <TypeAnimation
          texts={["Теперь когда вы представили своим индивидуальным воображением изменившийся мир, представьте, пожалуйста, что у вас в руках продукт этих изменений в том числе.  Именно особый способ упаковки информации предлагается как удовольствие открывать заново казалось бы понятные вещи. Посмотрите на экран, и представьте…"]}
        />
      </div>

      <div className="description__5">
        <TypeAnimation
          texts={["Представили?"]}
        />
      </div>
    </div>
}